import $ from "jquery";

$(function() {
  var trigger = $(".c-tab__nav a");

  trigger.click(function(e) {
    var tabTarget = $(this).data("tab");
    var tabItem = $(this)
      .parents(".c-tab")
      .find("#" + tabTarget);

    // set correct menu item
    $(this)
      .parents(".c-tab__nav")
      .find(".is-active")
      .removeClass("is-active");
    $(this).addClass("is-active");

    // set correct content
    $(this)
      .parents(".c-tab")
      .find(".c-tab__content.is-active")
      .removeClass("is-active");
    tabItem.addClass("is-active");

    e.preventDefault();
  });
});
